import { CustomerUserConfigLayoutNavigationTypes, CustomerUserConfigLayoutType, ResizerPlacement } from '@talos/kyoko';
import { Blotters } from '../components/Blotters/Blotters';
import { Candlesticks } from '../components/Candlesticks';
import { OrderForms } from '../components/OrderForms';
import { VolumeLadder } from '../components/VolumeLadder';
import { BLOTTERS_MIN_HEIGHT, MAIN_HEADER_HEIGHT, VOLUME_LADDER_HEIGHT } from '../styles/dimensions';
import { tradingMobileScreens } from './mobileScreens';
import type { LayoutComponent } from './types';

// Re-export these under their original names for convenience, until all consumers can be redirected to @talos/kyoko
export { CustomerUserConfigLayoutType as LayoutType, CustomerUserConfigLayoutNavigationTypes as NavigationTypes };

export const TradingLadderLayout: LayoutComponent = {
  headerSymbolSelector: false,
  columns: ['minmax(16rem,24rem)', 'minmax(16rem,1fr)', 'auto'],
  rows: [`minmax(${VOLUME_LADDER_HEIGHT}px,1fr)`, 'minmax(0px,1fr)', `minmax(${BLOTTERS_MIN_HEIGHT}px,1fr)`],
  parts: [
    {
      column: '1',
      row: '1/3',
      component: <VolumeLadder />,
    },
    {
      column: '2/3',
      row: '1/3',
      component: <Candlesticks />,
    },
    {
      column: '1/3',
      row: '3',
      component: <Blotters />,
      minHeight: BLOTTERS_MIN_HEIGHT,
      maxHeight: window.innerHeight - MAIN_HEADER_HEIGHT - VOLUME_LADDER_HEIGHT,
      resizable: ResizerPlacement.TOP,
    },
    {
      column: '3',
      row: '1/4',
      component: <OrderForms />,
      isOrderForms: true,
    },
  ],
  mobileScreens: tradingMobileScreens,
};
